


<ng-container *ngIf="tedDomainData()?.length; else empty">
  <div
    class="outter">
    <div class="line-through"></div>
    <div
      class="domain"
      *ngFor="let d of mappedTedDomainData(); let i = index"
      [class.hover-active]="d.tedNumber === tedDomainNumberForClickActive()"
      [class.click-active]="d.tedNumber == tedDomainNumberForClickActive()"
      [style.background]="d.color"
      [style.left]="d.left + '%'"
      [style.right]="d.right + '%'"
      (mouseenter)="onHover(d, rectElement)"
      (mouseleave)="onLeave()"
      (click)="onClick(d, i, rectElement)"
      #rectElement
    ></div>
    <!-- [class.hover-active]="d.tedNumber === tedDomainNumber()" -->
    <!-- <ng-container *ngIf="popupVisible()">
      <app-popup
        [activeDomain]="activeDomain()"
        (closePopup)="closePopup()"
      ></app-popup>
    </ng-container>
    <ng-container *ngIf="popupTooltipVisible()">
      <app-popup
        [activeDomain]="activeTooltipDomain()"
        [isTooltip]="true"
      ></app-popup>
    </ng-container> -->
  </div>
</ng-container>
<ng-template #empty>
  <p class="no-domain">No domain information for this entry</p>
</ng-template>
